import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="w-full">
      <Box
        sx={(theme) => ({
          position: "relative",
          zIndex: 60,
          backgroundColor: theme.palette.primary.main,
          color: "#fff",
        })}
      >
        <Box className="max-w-6xl mx-auto px-6 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          {/* 左：リンク */}
          <div className="flex flex-col items-center gap-2 text-sm md:flex-row md:gap-6">
            <Link to="/" className="opacity-90 hover:opacity-100">TOP</Link>
            <Link to="/company" className="opacity-90 hover:opacity-100">運営会社</Link>
            <Link to="/terms" className="opacity-90 hover:opacity-100">利用規約</Link>
            <Link to="/privacy" className="opacity-90 hover:opacity-100">プライバシーポリシー</Link>
          </div>

          {/* 右：コピーライト */}
          <div className="flex flex-col items-center md:items-end gap-1">
            <Typography variant="caption" sx={{ opacity: 0.8, textAlign: { xs: "center", md: "right" }, }}>
              Copyright © 2025 Afrofair internet. All Rights Reserved.
            </Typography>
            <Typography
              variant="caption"
              sx={{
                opacity: 0.8,
                display: "block",
                textAlign: "right",
                pr: 3,
              }}
            >
              特許出願中
            </Typography>
          </div>
        </Box>
      </Box>
    </footer>
  );
}
